;(function( $ ) {
    'use strict';
    $( document ).ready( function() {
        $( '.faq-list' ).each( function() {
            var $this = $( this ),
                $faqItems = $this.find( 'li' );

            $this.on( 'click', 'li', function() {
                var $self = $(this);
                // Add a class to the root item to tell us we're using JS now so we can stop with the CSS hacks
                $this.addClass( 'running' );

                if ( $self.hasClass( 'active' ) ) {
                    $self.removeClass( 'active' );
                }
                else {
                    $faqItems.not( $self ).removeClass( 'active' );
                    $self.addClass( 'active' );
                }
            } );
        } );
    } );
}( jQuery ));
